import Vue from 'vue'
import Vuex from 'vuex'

import modules from './modules'

Vue.use(Vuex)

const store = new Vuex.Store({
    mutations: {
        initialiseStore(state) {
            if (localStorage.getItem('orbiter_store')) {
                this.replaceState(
                    Object.assign(state, JSON.parse(localStorage.getItem('orbiter_store')))
                );
            }
        },
    },
    modules,
    // Enable strict mode in development to get a warning
    // when mutating state outside of a mutation.
    // https://vuex.vuejs.org/guide/strict.html
    strict: process.env.NODE_ENV !== 'production',
})

store.subscribe((mutation, state) => {
    localStorage.setItem('orbiter_store', JSON.stringify({...state}))
});

export default store

